import { render } from "./RegisterPanel.vue?vue&type=template&id=2a78c648&scoped=true&ts=true"
import script from "./RegisterPanel.vue?vue&type=script&lang=ts"
export * from "./RegisterPanel.vue?vue&type=script&lang=ts"

import "./RegisterPanel.vue?vue&type=style&index=0&id=2a78c648&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a78c648"]])

export default __exports__